"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyAndImportElements = exports.updateSettings = exports.updateList = exports.updateImageUrl = exports.updateCurrentElementSettings = exports.unsetLoadingState = exports.undoChanges = exports.toggleElementPreview = exports.storageKey = exports.setRootId = exports.setProjectId = exports.setLoadingState = exports.setListWithoutRestore = exports.setList = exports.setLanguage = exports.setAssignmentId = exports.savedKeys = exports.saveStateInStorage = exports.savePlayerSettings = exports.saveFlow = exports.saveDataDefinitions = exports.restoreState = exports.resetFlow = exports.removeRedos = exports.redoChanges = exports.moveElementToTrashWithoutChecking = exports.moveElementToTrash = exports.moveElementFromTrash = exports.moveElement = exports.loadFlow = exports.initializeSavedList = exports.initialState = exports.initialSettings = exports.importElements = exports.duplicateElement = exports["default"] = exports.completeSectionTree = exports.changeViewModeWithoutSave = exports.changeViewMode = exports.changePreviewSizeWithoutSave = exports.changePreviewSize = exports.changeCurrentElementWithoutSave = exports.changeCurrentElement = exports.batchUpdateAudio = exports.addElement = void 0;
var _reduxActions = require("redux-actions");
var _map2 = _interopRequireDefault(require("lodash/map"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _helpers = require("../other/helpers.js");
var _builder = require("../selectors/builder.js");
var _store = _interopRequireDefault(require("store"));
var _allElements = _interopRequireDefault(require("../allElements.js"));
var _allTemplates = require("../allTemplates.js");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _config = _interopRequireDefault(require("../config.js"));
var _window$cccisd, _handleActions;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var AppDefs = window.cccisd && window.cccisd.appDefs;
var Resources = (_window$cccisd = window.cccisd) === null || _window$cccisd === void 0 ? void 0 : _window$cccisd.resources;
var dynamicDataConnectors = AppDefs && AppDefs.flow && AppDefs.flow.variables || [];
var dynamicUserLists = AppDefs && AppDefs.flow && AppDefs.flow.userLists || [];
var defaultValues = AppDefs && AppDefs.flow && AppDefs.flow.defaultValues || [];
var storageKey = exports.storageKey = 'CccisdFlowCurrent'; // key for browser local storage
var savedKeys = exports.savedKeys = ['currentElementId', 'viewMode', 'previewSize'];

// Initial state
var initialSettings = exports.initialSettings = {
  name: 'Flow',
  handle: '',
  type: '',
  showOneElementPerPage: false,
  showRequiredState: false,
  showQuestionNumbers: false,
  showAdvancedSettings: false,
  overrideAccommodations: false,
  accommodations: {
    masking: false,
    highlighting: false,
    autoplayQuestions: false,
    autoplayChoices: false,
    autoplayInstructions: true,
    blockUserInteractions: false
  },
  playerTemplate: 'default',
  playerTemplateSettings: {}
};
var initialState = exports.initialState = {
  loading: false,
  elements: {},
  trash: [],
  currentElementId: 0,
  viewMode: 'preview',
  savedHash: '',
  savedElements: {},
  projectId: 0,
  assignmentId: 0,
  rootId: 0,
  newId: 1000000000,
  settings: initialSettings,
  previewSize: 'desktop',
  dynamicDataConnectors: (0, _helpers.checkForUniqueHandle)(dynamicDataConnectors),
  dynamicUserLists: (0, _helpers.checkForUniqueHandle)(dynamicUserLists),
  defaultValues: (0, _helpers.checkForUniqueHandle)(defaultValues),
  language: 'en',
  voices: Resources ? Object.entries(Resources.tts.voices).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return {
      language: value.LanguageCode.slice(0, 2),
      languageName: value.language,
      label: value.label,
      value: key,
      gender: value.Gender,
      url: value.url,
      order: function () {
        // Put Pedro and Miguel at the beginning of the list
        if (key === 'Pedro') {
          return -2;
        }
        if (key === 'Miguel') {
          return -1;
        }
        return 0;
      }()
    };
  }).sort(function (a, b) {
    return a.order - b.order;
  }) : [],
  allElements: _allElements["default"],
  config: _config["default"]
};

// Actions
var SET_LOADING_STATE = 'flow/builder/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'flow/builder/UNSET_LOADING_STATE';
var RESET_FLOW = 'flow/builder/RESET_FLOW';
var CHANGE_CURRENT_ELEMENT = 'flow/builder/CHANGE_CURRENT_ELEMENT';
var ADD_ELEMENT = 'flow/builder/ADD_ELEMENT';
var IMPORT_ELEMENTS = 'flow/builder/IMPORT_ELEMENTS';
var MOVE_ELEMENT = 'flow/builder/MOVE_ELEMENT';
var MOVE_ELEMENT_TO_TRASH = 'flow/builder/MOVE_ELEMENT_TO_TRASH';
var MOVE_ELEMENT_FROM_TRASH = 'flow/builder/MOVE_ELEMENT_FROM_TRASH';
var CHANGE_VIEW_MODE = 'flow/builder/CHANGE_VIEW_MODE';
var UPDATE_CURRENT_ELEMENT_SETTINGS = 'flow/builder/UPDATE_CURRENT_ELEMENT_SETTINGS';
var TOGGLE_ELEMENT_PREVIEW = 'flow/builder/TOGGLE_ELEMENT_PREVIEW';
var INITIALIZE_SAVED_LIST = 'flow/builder/INITIALIZE_SAVED_LIST';
var SET_LIST = 'flow/builder/SET_LIST';
var UPDATE_LIST = 'flow/builder/UPDATE_LIST';
var REMOVE_REDOS = 'flow/builder/REMOVE_REDOS';
var UNDO_CHANGES = 'flow/builder/UNDO_CHANGES';
var REDO_CHANGES = 'flow/builder/REDO_CHANGES';
var UPDATE_SETTINGS = 'flow/builder/UPDATE_SETTINGS';
var SET_ROOT_ID = 'flow/builder/SET_ROOT_ID';
var RESTORE_STATE = 'flow/builder/RESTORE_STATE';
var COMPLETE_SECTION_TREE = 'flow/builder/COMPLETE_SECTION_TREE';
var CHANGE_PREVIEW_SIZE = 'flow/builder/CHANGE_PREVIEW_SIZE';
var SET_PROJECT_ID = 'flow/builder/SET_PROJECT_ID';
var SET_ASSIGNMENT_ID = 'flow/builder/SET_ASSIGNMENT_ID';
var SET_LANGUAGE = 'flow/builder/SET_LANGUAGE';
var BATCH_UPDATE_AUDIO = 'flow/builder/BATCH_UPDATE_AUDIO';
var UPDATE_IMAGE_URL = 'flow/builder/UPDATE_IMAGE_URL';

// Action Creators
var setLoadingState = exports.setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
var unsetLoadingState = exports.unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
var resetFlow = exports.resetFlow = (0, _reduxActions.createAction)(RESET_FLOW);
var changeCurrentElementWithoutSave = exports.changeCurrentElementWithoutSave = (0, _reduxActions.createAction)(CHANGE_CURRENT_ELEMENT);
var addElement = exports.addElement = (0, _reduxActions.createAction)(ADD_ELEMENT);
var importElements = exports.importElements = (0, _reduxActions.createAction)(IMPORT_ELEMENTS);
var moveElement = exports.moveElement = (0, _reduxActions.createAction)(MOVE_ELEMENT);
var moveElementToTrashWithoutChecking = exports.moveElementToTrashWithoutChecking = (0, _reduxActions.createAction)(MOVE_ELEMENT_TO_TRASH);
var moveElementFromTrash = exports.moveElementFromTrash = (0, _reduxActions.createAction)(MOVE_ELEMENT_FROM_TRASH);
var changeViewModeWithoutSave = exports.changeViewModeWithoutSave = (0, _reduxActions.createAction)(CHANGE_VIEW_MODE);
var updateCurrentElementSettings = exports.updateCurrentElementSettings = (0, _reduxActions.createAction)(UPDATE_CURRENT_ELEMENT_SETTINGS);
var toggleElementPreview = exports.toggleElementPreview = (0, _reduxActions.createAction)(TOGGLE_ELEMENT_PREVIEW);
var initializeSavedList = exports.initializeSavedList = (0, _reduxActions.createAction)(INITIALIZE_SAVED_LIST);
var setListWithoutRestore = exports.setListWithoutRestore = (0, _reduxActions.createAction)(SET_LIST);
var updateList = exports.updateList = (0, _reduxActions.createAction)(UPDATE_LIST);
var removeRedos = exports.removeRedos = (0, _reduxActions.createAction)(REMOVE_REDOS);
var undoChanges = exports.undoChanges = (0, _reduxActions.createAction)(UNDO_CHANGES);
var redoChanges = exports.redoChanges = (0, _reduxActions.createAction)(REDO_CHANGES);
var updateSettings = exports.updateSettings = (0, _reduxActions.createAction)(UPDATE_SETTINGS);
var setRootId = exports.setRootId = (0, _reduxActions.createAction)(SET_ROOT_ID);
var restoreState = exports.restoreState = (0, _reduxActions.createAction)(RESTORE_STATE);
var completeSectionTree = exports.completeSectionTree = (0, _reduxActions.createAction)(COMPLETE_SECTION_TREE);
var changePreviewSizeWithoutSave = exports.changePreviewSizeWithoutSave = (0, _reduxActions.createAction)(CHANGE_PREVIEW_SIZE);
var setProjectId = exports.setProjectId = (0, _reduxActions.createAction)(SET_PROJECT_ID);
var setAssignmentId = exports.setAssignmentId = (0, _reduxActions.createAction)(SET_ASSIGNMENT_ID);
var setLanguage = exports.setLanguage = (0, _reduxActions.createAction)(SET_LANGUAGE);
var batchUpdateAudio = exports.batchUpdateAudio = (0, _reduxActions.createAction)(BATCH_UPDATE_AUDIO);
var updateImageUrl = exports.updateImageUrl = (0, _reduxActions.createAction)(UPDATE_IMAGE_URL);
var moveElementToTrash = exports.moveElementToTrash = function moveElementToTrash(id) {
  return function (dispatch, getState) {
    var state = getState().flow.builder;
    if (!(0, _helpers.allowRemoveElement)(state.elements, state.rootId, id)) {
      (0, _cccisdNotification["default"])({
        message: 'You cannot delete this element because other elements have data connectors linked to it',
        type: 'danger',
        duration: 10000
      });
    } else {
      dispatch(moveElementToTrashWithoutChecking(id));
    }
  };
};
var setList = exports.setList = function setList() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return function (dispatch, getState) {
    dispatch(setListWithoutRestore.apply(void 0, args));
    dispatch(restoreState({
      savedState: _store["default"].get(storageKey) || {},
      keys: savedKeys
    }));
  };
};
var saveStateInStorage = exports.saveStateInStorage = function saveStateInStorage() {
  return function (dispatch, getState) {
    var state = getState().flow.builder;
    if (state.rootId !== 0) {
      var saved = _store["default"].get(storageKey) || {};
      saved[state.rootId] = (0, _pick2["default"])(state, savedKeys);
      _store["default"].set(storageKey, saved);
    }
  };
};
var changeCurrentElement = exports.changeCurrentElement = function changeCurrentElement() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return function (dispatch, getState) {
    dispatch(changeCurrentElementWithoutSave.apply(void 0, args));
    dispatch(saveStateInStorage());
  };
};
var changeViewMode = exports.changeViewMode = function changeViewMode() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return function (dispatch, getState) {
    dispatch(changeViewModeWithoutSave.apply(void 0, args));
    dispatch(saveStateInStorage());
  };
};
var changePreviewSize = exports.changePreviewSize = function changePreviewSize() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch(changePreviewSizeWithoutSave.apply(void 0, args));
            dispatch(saveStateInStorage());

            // just to trigger all resize listeners
            // wait to finish animation
            _context.next = 4;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 500);
            });
          case 4:
            window.dispatchEvent(new Event('resize'));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var verifyAndImportElements = exports.verifyAndImportElements = function verifyAndImportElements(_ref4) {
  var content = _ref4.content,
    parentId = _ref4.parentId,
    beforeId = _ref4.beforeId;
  return function (dispatch, getState) {
    try {
      var data = JSON.parse(content);
      if (data.version !== _config["default"].exportVersion) {
        throw new Error("The import file version ".concat(data.version, " is not supported"));
      }

      // Check if components exist
      (function () {
        var state = getState().flow.builder;
        var flowTypes = (0, _helpers.getFlowTypes)();
        var importingTypes = (0, _filter2["default"])(data.elements, function (o) {
          return o.type;
        }).map(function (o) {
          return o.type;
        });
        var existingTypes = flowTypes[state.settings.type].components;
        var diff = (0, _uniq2["default"])((0, _difference2["default"])(importingTypes, existingTypes));
        if (diff.length > 0) {
          throw new Error("The are missing components: \"".concat(diff.join('", "'), "\""));
        }
      })();

      // Check if templates exist
      (function () {
        var importingTemplates = (0, _filter2["default"])(data.elements, function (o) {
          return o.type && o.settings && o.settings.template;
        }).reduce(function (result, o) {
          result[o.type] = result[o.type] || [];
          if (!result[o.type].includes(o.settings.template)) {
            result[o.type].push(o.settings.template);
          }
          return result;
        }, {});
        (0, _forEach2["default"])(importingTemplates, function (value, key) {
          var list = (0, _allTemplates.getTemplateList)('components', key).map(function (o) {
            return o.name;
          });
          var diff = (0, _difference2["default"])(value, list);
          if (diff.length > 0) {
            throw new Error("The are missing templates for the \"".concat(key, "\" element: \"").concat(diff.join('", "'), "\""));
          }
        });
      })();

      // Check if player templates exist
      (function () {
        var importingTemplates = (0, _uniq2["default"])((0, _filter2["default"])(data.elements, function (o) {
          return o.settings && o.settings.blockPlayerTemplate;
        }).map(function (o) {
          return o.settings.blockPlayerTemplate;
        }));
        var existingTemplates = (0, _allTemplates.getTemplateList)('players', 'flow').map(function (o) {
          return o.name;
        });
        var diff = (0, _difference2["default"])(importingTemplates, existingTemplates);
        if (diff.length > 0) {
          throw new Error("The are missing player templates: \"".concat(diff.join('", "'), "\""));
        }
      })();
      dispatch(importElements(_objectSpread(_objectSpread({}, (0, _pick2["default"])(data, ['elements', 'topId'])), {}, {
        parentId: parentId,
        beforeId: beforeId
      })));
      (0, _cccisdNotification["default"])('The survey has been imported');
    } catch (e) {
      (0, _cccisdNotification["default"])({
        message: e.message,
        type: 'danger',
        duration: 10000
      });
    }
  };
};
var duplicateElement = exports.duplicateElement = function duplicateElement(id) {
  return function (dispatch, getState) {
    var state = getState().flow.builder;
    var parent = (0, _find2["default"])(state.elements, function (item) {
      return item.children && item.children.includes(id);
    });
    var parentChildren = parent.children;
    var index = parentChildren.indexOf(id);
    // If there is no next element then it will pass undefined
    var beforeId = parentChildren[index + 1];
    var data = (0, _helpers.exportFlow)({
      elements: state.elements,
      topId: id,
      theSameFlow: true
    });
    dispatch(importElements({
      elements: data.elements,
      topId: data.topId,
      parentId: parent.id,
      beforeId: beforeId
    }));
  };
};
var saveDataDefinitions = exports.saveDataDefinitions = function saveDataDefinitions(flowId, codebookId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var state, dataDefinitions, repeatableDataDefinitions, count, metricsVariables, variables, typeMatch, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            dataDefinitions = {};
            repeatableDataDefinitions = {};
            count = 1;
            (0, _builder.getElementsInOrder)(state.flow.builder).forEach(function (element) {
              var elementType = (0, _find2["default"])(_allElements["default"], {
                code: element.type
              });

              // Regular data definitions
              if (elementType && (0, _isFunction2["default"])(elementType.getDataDefinitions)) {
                var elementDefinitions = elementType.getDataDefinitions(element.id, element.settings);
                Object.assign(dataDefinitions, (0, _mapValues2["default"])(elementDefinitions, function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    order: count++
                  });
                }));
                var title = "Duration for entity ".concat(element.id);
                Object.values(elementDefinitions).forEach(function (value) {
                  if (value.title) {
                    title = value.title;
                  }
                });
                var prefix = '';
                if ((0, _isFunction2["default"])(elementType.getMetricsPrefix)) {
                  prefix = elementType.getMetricsPrefix() + '_';
                }
                dataDefinitions["".concat(element.id, "_duration")] = {
                  questionType: element.type,
                  label: "Duration for entity ".concat(element.id),
                  title: title,
                  titleHtml: title,
                  type: 'number',
                  reportHeader: "".concat(prefix).concat(element.id, "_duration"),
                  variableType: 'detailed_usage',
                  tags: {
                    system: ['duration']
                  },
                  order: count++
                };
              }

              // Repeatable data definitions
              if (elementType && (0, _isFunction2["default"])(elementType.getRepeatableDataDefinitions)) {
                var _elementDefinitions = elementType.getRepeatableDataDefinitions(element.id, element.settings);
                Object.assign(repeatableDataDefinitions, (0, _mapValues2["default"])(_elementDefinitions, function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    order: count++
                  });
                }));
              }
            });

            // Get data definitions for variables
            metricsVariables = state.flow.builder.settings.metricsVariables || [];
            variables = (0, _get2["default"])(window, 'cccisd.appDefs.flow.variables', []).filter(function (item) {
              return ['string', 'number'].includes(item.type) && metricsVariables.includes(item.handle);
            });
            typeMatch = {
              string: 'string',
              number: 'int'
            };
            variables.forEach(function (variable) {
              dataDefinitions["".concat(flowId, "_app_variable_").concat(variable.handle)] = {
                questionType: 'appVariable',
                label: variable.label,
                title: variable.label,
                titleHtml: variable.label,
                type: typeMatch[variable.type] || variable.type,
                reportHeader: "app_variable_".concat(variable.handle),
                variableType: 'detailed_usage',
                tags: {
                  system: ['app_variable']
                },
                order: count++
              };
            });
            dataDefinitions = {
              $schema: 'http://json-schema.org/draft-04/schema#',
              title: state.flow.builder.settings.name,
              sourceType: 'flow',
              sourceId: flowId,
              type: 'object',
              properties: _objectSpread({}, dataDefinitions),
              patternProperties: _objectSpread({}, repeatableDataDefinitions)
            };
            data = {
              definition: JSON.stringify(dataDefinitions)
            };
            if (codebookId) {
              data.codebook_id = codebookId;
            }
            _context2.next = 14;
            return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.source.definition'), data);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var loadFlow = exports.loadFlow = function loadFlow(flowId) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var response, attributes, settings;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch(resetFlow());
            dispatch(setLoadingState());

            // Get flow data
            _context3.next = 4;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.show', {
              flow: flowId
            }));
          case 4:
            response = _context3.sent;
            attributes = response.data.data.attributes;
            settings = _objectSpread(_objectSpread({}, _typeof(attributes.settings) === 'object' ? attributes.settings : {}), {}, {
              name: attributes.name,
              handle: attributes.handle || '',
              type: attributes.type,
              language: attributes.language
            });
            dispatch(setProjectId(response.data.data.group.id));
            dispatch(setAssignmentId(response.data.data.assignment.id));
            dispatch(setLanguage(attributes.language));
            dispatch(updateSettings(_objectSpread(_objectSpread({}, initialState.settings), settings)));

            // Get flow outline
            _context3.next = 13;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.builder.entity.outline', {
              flow_id: flowId
            }));
          case 13:
            response = _context3.sent;
            dispatch(setList({
              list: response.data.data.tree,
              elementTypes: _allElements["default"]
            }));
            dispatch(unsetLoadingState());
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var savePlayerSettings = exports.savePlayerSettings = function savePlayerSettings(flowId) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var state, builder, data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            state = getState();
            builder = state.flow.builder;
            data = {
              settings: JSON.stringify((0, _omit2["default"])(builder.settings, ['name', 'handle', 'type']))
            };
            _context4.next = 5;
            return _cccisdAxios["default"].put(Boilerplate.route('flow.update', {
              flow: flowId
            }), data);
          case 5:
            (0, _cccisdNotification["default"])('The player settings have been saved');
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var saveFlow = exports.saveFlow = function saveFlow(flowId, codebookId) {
  var saveFlowThunk = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var state, builder, tree, response, needToSaveAgain;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            dispatch(setLoadingState());
            state = getState();
            builder = state.flow.builder; // Save flow tree
            tree = (0, _builder.getElementTreeForSaving)(builder);
            (0, _forEach2["default"])((0, _builder.getDeletedElements)(builder), function (deletedId) {
              // Add deleted elements
              tree.children.push({
                id: deletedId,
                status: 'deleted'
              });
            });
            _context5.next = 7;
            return _cccisdAxios["default"].put(Boilerplate.route('flow.builder.entity.batch.update', {
              flow_id: flowId
            }), {
              data: {
                tree: tree
              }
            });
          case 7:
            response = _context5.sent;
            // Checking if we have some data connectors to the new elements
            // In this case we have to get real ids and then save it again
            needToSaveAgain = (0, _helpers.checkIfNeedToSaveAgain)(builder.elements, response.data.data);
            dispatch(updateList(response.data.data));
            if (!needToSaveAgain) {
              _context5.next = 15;
              break;
            }
            _context5.next = 13;
            return saveFlowThunk(dispatch, getState);
          case 13:
            _context5.next = 18;
            break;
          case 15:
            dispatch(saveStateInStorage());
            dispatch(unsetLoadingState());
            dispatch(saveDataDefinitions(flowId, codebookId));
          case 18:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function saveFlowThunk(_x9, _x10) {
      return _ref8.apply(this, arguments);
    };
  }();
  return saveFlowThunk;
};

// Reducer
var _default = exports["default"] = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), RESET_FLOW, function (state, action) {
  return _objectSpread({}, initialState);
}), ADD_ELEMENT, function (state, action) {
  var _action$payload = action.payload,
    element = _action$payload.element,
    settings = _action$payload.settings,
    parentId = _action$payload.parentId,
    beforeId = _action$payload.beforeId;
  if (!parentId) {
    parentId = state.rootId;
    beforeId = 0;
  }
  if (!state.elements[parentId]) {
    throw new Error("There is no element with parentId=".concat(parentId));
  }
  var newId = state.newId;
  var newElement = _objectSpread({
    id: newId,
    isNew: true,
    undoIterator: 0,
    // for new element we use element.code
    // for duplicated element we use element.type
    type: element.code || element.type,
    settings: settings,
    settingsHash: (0, _helpers.getObjectHash)(settings)
  }, (0, _pick2["default"])(element, ['skipPlaying', 'returnControlAfterChildren', 'isAloneOnThePage', 'isParentAllowed', 'isChildAllowed']));
  if (element.isAdult) {
    newElement.isAdult = true;
    newElement.children = [];
  }
  var elementList = state.elements[parentId].children;
  var beforeIndex = elementList.indexOf(beforeId);
  var newElementList;
  if (beforeIndex === -1) {
    newElementList = [].concat(_toConsumableArray(elementList), [newId]);
  } else {
    newElementList = [].concat(_toConsumableArray(elementList.slice(0, beforeIndex)), [newId], _toConsumableArray(elementList.slice(beforeIndex)));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    newId: newId + 1,
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty(_defineProperty({}, parentId, _objectSpread(_objectSpread({}, state.elements[parentId]), {}, {
      children: newElementList
    })), newId, newElement)),
    currentElementId: (0, _isEmpty2["default"])(settings) ? state.currentElementId : newId
  });
}), IMPORT_ELEMENTS, function (state, action) {
  var _action$payload2 = action.payload,
    parentId = _action$payload2.parentId,
    beforeId = _action$payload2.beforeId;
  if (!parentId) {
    parentId = state.rootId;
    beforeId = 0;
  }
  if (!state.elements[parentId]) {
    throw new Error("There is no element with parentId=".concat(parentId));
  }
  var _replaceIds = (0, _helpers.replaceIds)(action.payload.elements, action.payload.topId, state.newId),
    elements = _replaceIds.elements,
    topId = _replaceIds.topId,
    newId = _replaceIds.newId;
  var topElement = elements[topId];
  var additionalChildren = topElement.type ? [topId] : elements[topId].children;
  var children = state.elements[parentId].children;
  var beforeIndex = children.indexOf(beforeId);
  var newChildren;
  if (beforeIndex === -1) {
    newChildren = [].concat(_toConsumableArray(children), _toConsumableArray(additionalChildren));
  } else {
    newChildren = [].concat(_toConsumableArray(children.slice(0, beforeIndex)), _toConsumableArray(additionalChildren), _toConsumableArray(children.slice(beforeIndex)));
  }
  var newElements = topElement.type ? elements : (0, _pickBy2["default"])(elements, function (o) {
    return o.id !== topId;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, parentId, _objectSpread(_objectSpread({}, state.elements[parentId]), {}, {
      children: newChildren
    })), (0, _mapValues2["default"])(newElements, function (o) {
      return _objectSpread(_objectSpread({}, o), {}, {
        isNew: true,
        undoIterator: 0,
        settingsHash: (0, _helpers.getObjectHash)(o.settings)
      });
    })),
    newId: newId
  });
}), MOVE_ELEMENT, function (state, action) {
  var _action$payload3 = action.payload,
    id = _action$payload3.id,
    parentId = _action$payload3.parentId,
    beforeId = _action$payload3.beforeId;
  if (!state.elements[parentId]) {
    throw new Error("There is no element with parentId=".concat(parentId));
  }
  var elementList = (0, _difference2["default"])(state.elements[parentId].children, [id]);
  var beforeIndex = elementList.indexOf(beforeId);
  var newElementList;
  if (beforeIndex === -1) {
    newElementList = [].concat(_toConsumableArray(elementList), [id]);
  } else {
    newElementList = [].concat(_toConsumableArray(elementList.slice(0, beforeIndex)), [id], _toConsumableArray(elementList.slice(beforeIndex)));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, (0, _mapValues2["default"])(state.elements, function (element) {
      if (!element.children) {
        return element;
      }
      return _objectSpread(_objectSpread({}, element), {}, {
        children: (0, _difference2["default"])(element.children, [id])
      });
    })), {}, _defineProperty({}, parentId, _objectSpread(_objectSpread({}, state.elements[parentId]), {}, {
      children: newElementList
    })))
  });
}), CHANGE_CURRENT_ELEMENT, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentElementId: action.payload,
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, action.payload, _objectSpread({}, (0, _omit2["default"])(state.elements[action.payload], 'showPreview'))))
  });
}), CHANGE_VIEW_MODE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    viewMode: action.payload,
    elements: (0, _mapValues2["default"])(state.elements, function (element) {
      return (0, _omit2["default"])(element, 'showPreview');
    })
  });
}), UPDATE_CURRENT_ELEMENT_SETTINGS, function (state, action) {
  var id = state.currentElementId;
  var newSettings = action.payload;
  var oldSettingsHash = state.elements[id].settingsHash;
  var newSettingsHash = (0, _helpers.getObjectHash)(newSettings);
  if (oldSettingsHash === newSettingsHash) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, state.elements[id]), {}, {
      redoSettings: null,
      settings: newSettings,
      settingsHash: newSettingsHash
    })))
  });
}), TOGGLE_ELEMENT_PREVIEW, function (state, action) {
  var viewMode = state.viewMode;
  var isCurrent = state.currentElementId === action.payload;
  var element = state.elements[action.payload];
  var showPreview;
  if (element.showPreview === undefined) {
    showPreview = viewMode === 'preview' || isCurrent ? false : true;
  } else {
    showPreview = !element.showPreview;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, action.payload, _objectSpread(_objectSpread({}, element), {}, {
      showPreview: showPreview
    })))
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, INITIALIZE_SAVED_LIST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    savedElements: state.elements
  });
}), REMOVE_REDOS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: (0, _mapValues2["default"])(state.elements, function (element) {
      return _objectSpread(_objectSpread({}, element), {}, {
        redoSettings: null
      });
    })
  });
}), UNDO_CHANGES, function (state, action) {
  var id = action.payload;
  var savedElement = state.savedElements[id];
  if (!savedElement) {
    return state;
  }
  var element = state.elements[id];
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, element), {}, {
      undoIterator: element.undoIterator - 1,
      redoSettings: element.settings,
      settings: savedElement.settings,
      settingsHash: savedElement.settingsHash
    })))
  });
}), REDO_CHANGES, function (state, action) {
  var id = action.payload;
  var element = state.elements[id];
  if (!element || !element.redoSettings) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, element), {}, {
      undoIterator: element.undoIterator + 1,
      redoSettings: null,
      settings: element.redoSettings,
      settingsHash: (0, _helpers.getObjectHash)(element.redoSettings)
    })))
  });
}), UPDATE_SETTINGS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    settings: _objectSpread(_objectSpread({}, state.settings), action.payload)
  });
}), SET_ROOT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    rootId: action.payload
  });
}), SET_PROJECT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    projectId: action.payload
  });
}), SET_ASSIGNMENT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    assignmentId: action.payload
  });
}), SET_LANGUAGE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    language: action.payload
  });
}), SET_LIST, function (state, action) {
  var _action$payload4 = action.payload,
    list = _action$payload4.list,
    elementTypes = _action$payload4.elementTypes;
  var rootId = list.id;
  var elements = {};
  function processChildren(parent) {
    var children = parent.children ? parent.children.map(function (element) {
      return element.id;
    }) : [];
    if (parent.id === rootId) {
      elements[rootId] = {
        id: rootId,
        children: children
      };
      if (parent.children) {
        parent.children.forEach(function (child) {
          return processChildren(child);
        });
      }
    } else {
      var elementType = (0, _find2["default"])(elementTypes, {
        code: parent.type
      });
      if (!elementType) {
        throw new Error("Unknown type \"".concat(parent.type, "\""));
      }
      var settings = parent.content[0];
      elements[parent.id] = _objectSpread({
        id: parent.id,
        type: parent.type,
        undoIterator: 0,
        settingsId: settings.id,
        settings: settings.content,
        settingsHash: (0, _helpers.getObjectHash)(settings.content)
      }, (0, _pick2["default"])(elementType, ['skipPlaying', 'returnControlAfterChildren', 'isAloneOnThePage', 'isParentAllowed', 'isChildAllowed']));
      if (elementType.isAdult) {
        elements[parent.id].isAdult = true;
        elements[parent.id].children = children;
        if (parent.children) {
          parent.children.forEach(function (child) {
            return processChildren(child);
          });
        }
      }
    }
  }
  processChildren(list);
  return _objectSpread(_objectSpread({}, state), {}, {
    rootId: rootId,
    currentElementId: elements[rootId].children[0],
    elements: elements,
    savedElements: elements,
    trash: []
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, UPDATE_LIST, function (state, action) {
  var currentElementId = state.currentElementId;
  var elements = {};
  var replacements = {};
  (0, _forEach2["default"])(state.elements, function (item, key) {
    if (!item.isNew) {
      elements[key] = item;
      return;
    }
    var found = (0, _find2["default"])(action.payload, {
      tmpId: +key
    });
    if (!found) {
      throw new Error("There is no element with tmpId=".concat(item.id));
    }
    replacements[key] = found.id;

    // Change currentElementId if it was the new element
    if (+key === currentElementId) {
      currentElementId = found.id;
    }
    elements[found.id] = _objectSpread(_objectSpread({}, (0, _omit2["default"])(item, 'isNew')), {}, {
      id: found.id,
      settingsId: found.content[0].id
    });
  });
  elements = (0, _mapValues2["default"])(elements, function (item) {
    if (!item.children) {
      return item;
    }
    return _objectSpread(_objectSpread({}, item), {}, {
      children: item.children.map(function (id) {
        return replacements[id] || id;
      })
    });
  });
  function replaceConnectorIds(item, key, collection) {
    if (!(0, _isObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
      return;
    }
    if ((0, _isObject2["default"])(item) && item.instance === 'dataConnector' && item.category === 'flow') {
      collection[key] = _objectSpread(_objectSpread({}, item), {}, {
        id: replacements[item.id] || item.id
      });
      return;
    }
    (0, _forEach2["default"])(item, replaceConnectorIds);
  }
  replaceConnectorIds(elements);
  return _objectSpread(_objectSpread({}, state), {}, {
    currentElementId: currentElementId,
    elements: elements,
    savedElements: elements,
    trash: []
  });
}), MOVE_ELEMENT_TO_TRASH, function (state, action) {
  var id = action.payload;
  function getAllDescendantIds(elementId) {
    if (!state.elements[elementId].children) {
      return [];
    }
    return state.elements[elementId].children.reduce(function (acc, childId) {
      return [].concat(_toConsumableArray(acc), [childId], _toConsumableArray(getAllDescendantIds(childId)));
    }, []);
  }
  var movedIds = [id].concat(_toConsumableArray(getAllDescendantIds(id)));
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: (0, _mapValues2["default"])((0, _omit2["default"])(state.elements, movedIds), function (element) {
      if (!element.children) {
        return element;
      }
      return _objectSpread(_objectSpread({}, element), {}, {
        children: (0, _difference2["default"])(element.children, movedIds)
      });
    }),
    trash: [].concat(_toConsumableArray((0, _map2["default"])((0, _pick2["default"])(state.elements, movedIds), function (element) {
      var result = (0, _helpers.removeDataConnectors)((0, _omit2["default"])(element, 'children'));
      if (result.isAdult) {
        result.children = [];
      }
      return result;
    })), _toConsumableArray(state.trash))
  });
}), MOVE_ELEMENT_FROM_TRASH, function (state, action) {
  var _action$payload5 = action.payload,
    id = _action$payload5.id,
    parentId = _action$payload5.parentId,
    _action$payload5$befo = _action$payload5.beforeId,
    beforeId = _action$payload5$befo === void 0 ? 0 : _action$payload5$befo;
  if (!state.elements[parentId]) {
    throw new Error("There is no element with parentId=".concat(parentId));
  }
  var element = (0, _find2["default"])(state.trash, {
    id: id
  });
  var elementList = state.elements[parentId].children;
  var beforeIndex = elementList.indexOf(beforeId);
  var newElementList;
  if (beforeIndex === -1) {
    newElementList = [].concat(_toConsumableArray(elementList), [id]);
  } else {
    newElementList = [].concat(_toConsumableArray(elementList.slice(0, beforeIndex)), [id], _toConsumableArray(elementList.slice(beforeIndex)));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty(_defineProperty({}, parentId, _objectSpread(_objectSpread({}, state.elements[parentId]), {}, {
      children: newElementList
    })), id, element)),
    trash: (0, _filter2["default"])(state.trash, function (item) {
      return item.id !== id;
    })
  });
}), RESTORE_STATE, function (state, action) {
  var _action$payload6 = action.payload,
    savedState = _action$payload6.savedState,
    keys = _action$payload6.keys;
  if (!savedState[state.rootId]) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), (0, _pick2["default"])(savedState[state.rootId], keys));
}), COMPLETE_SECTION_TREE, function (state, action) {
  var sectionCount = action.payload;
  var rootId = state.rootId,
    elements = state.elements;

  // Check if all the top level elements are adult
  elements[rootId].children.forEach(function (child) {
    if (!elements[child].isAdult) {
      throw new Error('Every top level element should be an adult');
    }
  });
  var count = elements[rootId].children.length;
  if (count >= sectionCount) {
    return state;
  }
  var newId = state.newId;
  var newElements = {};
  var newElementsIds = [];
  for (var i = 0; i < sectionCount - count; i++) {
    newElements[newId] = {
      id: newId,
      type: 'section',
      isNew: true,
      undoIterator: 0,
      settings: {},
      settingsHash: (0, _helpers.getObjectHash)({}),
      isAdult: true,
      children: []
    };
    newElementsIds.push(newId);
    newId++;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    newId: newId,
    elements: _objectSpread(_objectSpread(_objectSpread({}, elements), newElements), {}, _defineProperty({}, rootId, _objectSpread(_objectSpread({}, elements[rootId]), {}, {
      children: [].concat(_toConsumableArray(elements[rootId].children), newElementsIds)
    })))
  });
}), BATCH_UPDATE_AUDIO, function (state, action) {
  var _action$payload7 = action.payload,
    source = _action$payload7.source,
    tts = _action$payload7.tts;
  var newElements = (0, _cloneDeep2["default"])(state.elements);
  var _iterator = _createForOfIteratorHelper(source),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _field;
      var item = _step.value;
      var fullPath = "".concat(item.elementId, ".settings.").concat(item.path);
      var fieldTts = tts["".concat(item.elementId, "_").concat(item.path)];
      var meta = {
        tts: {
          voice: item.voice,
          text: item.text
        },
        audio: {
          id: fieldTts.resourceId,
          resourceId: fieldTts.resourceId,
          isAsset: true,
          url: fieldTts.url
        }
      };
      var field = (0, _get2["default"])(newElements, fullPath);
      if ((_field = field) !== null && _field !== void 0 && _field.content) {
        field = _objectSpread(_objectSpread({}, field), {}, {
          meta: _objectSpread(_objectSpread({}, field.meta), meta)
        });
      } else {
        field = {
          content: field,
          meta: meta
        };
      }
      (0, _set2["default"])(newElements, fullPath, field);

      // regenerate settings hash
      newElements[item.elementId].settingsHash = (0, _helpers.getObjectHash)(newElements[item.elementId].settings);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: newElements
  });
}), CHANGE_PREVIEW_SIZE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    previewSize: action.payload
  });
}), UPDATE_IMAGE_URL, function (state, action) {
  var _action$payload8 = action.payload,
    oldUrl = _action$payload8.oldUrl,
    newUrl = _action$payload8.newUrl;
  var regex = new RegExp("".concat(oldUrl), 'g');
  var newElements = (0, _cloneDeep2["default"])(state.elements);
  for (var _i = 0, _Object$values = Object.values(newElements); _i < _Object$values.length; _i++) {
    var element = _Object$values[_i];
    var settings = element.settings ? JSON.stringify(element.settings) : '';
    if (settings.includes(oldUrl)) {
      var newSettings = JSON.parse(settings.replace(regex, newUrl));
      element.settings = newSettings;
      element.settingsHash = (0, _helpers.getObjectHash)(newSettings);
    }
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: newElements
  });
})), initialState);